import { motion } from 'framer-motion';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">サービスについて</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            国際的に認められた指標を用いて、ご自身の肝臓の状態を知るための情報提供サービスです
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="p-8 bg-gradient-to-br from-blue-50 to-white rounded-2xl border border-blue-100"
          >
            <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6">
              <i className="ri-file-text-line text-blue-600 text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">情報提供サービス</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              本サービスは医療行為・診断・治療を行うものではありません。健康情報の提供を目的としています。
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="p-8 bg-gradient-to-br from-green-50 to-white rounded-2xl border border-green-100"
          >
            <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mb-6">
              <i className="ri-global-line text-green-600 text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">国際指標を使用</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              FIB-4 Indexなど、世界的に利用されている肝機能指標を用いて計算を行います。
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="p-8 bg-gradient-to-br from-purple-50 to-white rounded-2xl border border-purple-100"
          >
            <div className="w-16 h-16 flex items-center justify-center bg-purple-100 rounded-full mb-6">
              <i className="ri-shield-check-line text-purple-600 text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">プライバシー保護</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              氏名・住所・生年月日は取得しません。匿名でご利用いただけます。
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-16 p-8 bg-gradient-to-r from-blue-50 to-green-50 rounded-2xl border border-gray-200"
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">FIB-4 Indexとは</h3>
          <div className="max-w-4xl mx-auto">
            <p className="text-sm text-gray-700 leading-relaxed mb-6">
              FIB-4 Indexは、年齢、AST、ALT、血小板数から計算される肝線維化の評価指標です。
              世界中の医療機関で広く使用されており、肝臓の状態を評価する際の参考情報として活用されています。
            </p>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="p-5 bg-white rounded-lg border border-gray-200">
                <div className="text-center mb-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full mx-auto mb-2"></div>
                  <p className="text-sm font-bold text-gray-900">&lt; 1.3</p>
                </div>
                <p className="text-xs text-gray-600 text-center">低リスクグループ</p>
              </div>
              <div className="p-5 bg-white rounded-lg border border-gray-200">
                <div className="text-center mb-3">
                  <div className="w-3 h-3 bg-orange-500 rounded-full mx-auto mb-2"></div>
                  <p className="text-sm font-bold text-gray-900">1.3 - 2.67</p>
                </div>
                <p className="text-xs text-gray-600 text-center">中リスクグループ</p>
              </div>
              <div className="p-5 bg-white rounded-lg border border-gray-200">
                <div className="text-center mb-3">
                  <div className="w-3 h-3 bg-red-500 rounded-full mx-auto mb-2"></div>
                  <p className="text-sm font-bold text-gray-900">&gt; 2.67</p>
                </div>
                <p className="text-xs text-gray-600 text-center">高リスクグループ</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;